export default {
    page: function() {
        this.loadOrders()
    },
}
